import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

const ICONS = {
  'logo-aq': require('!raw-loader!../../../static/logo-aq.svg'),
  'logo-fb': require('!raw-loader!../../../static/logo-fb.svg'),
  'confirm-check': require('!raw-loader!../../../static/confirm-check.svg'),
  'checkbox-unchecked': require('!raw-loader!../../../static/checkbox-unchecked.svg'),
  'checkbox-checked': require('!raw-loader!../../../static/checkbox-checked.svg'),
  'checkmark-datepicker': require('!raw-loader!../../../static/checkmark-datepicker.svg'),
  'dropdown-triangle': require('!raw-loader!../../../static/dropdown-triangle.svg'),
  'onboarding-account': require('!raw-loader!../../../static/onboarding/account.svg'),
  'onboarding-invoices': require('!raw-loader!../../../static/onboarding/invoices.svg'),
  'onboarding-pools': require('!raw-loader!../../../static/onboarding/pools.svg'),
  'onboarding-positions': require('!raw-loader!../../../static/onboarding/positions.svg'),
  'onboarding-reports': require('!raw-loader!../../../static/onboarding/reports.svg'),
  'onboarding-timecards': require('!raw-loader!../../../static/onboarding/timecards.svg'),
  'onboarding-diversity': require('!raw-loader!../../../static/onboarding/diversity.svg'),
  'onboarding-account-vt': require('!raw-loader!../../../static/onboarding/account-VT.svg'),
  'onboarding-invoices-vt': require('!raw-loader!../../../static/onboarding/invoices-VT.svg'),
  'onboarding-pools-vt': require('!raw-loader!../../../static/onboarding/pools-VT.svg'),
  'onboarding-positions-vt': require('!raw-loader!../../../static/onboarding/positions-VT.svg'),
  'onboarding-reports-vt': require('!raw-loader!../../../static/onboarding/reports-VT.svg'),
  'onboarding-timecards-vt': require('!raw-loader!../../../static/onboarding/timecards-VT.svg'),
  'onboarding-diversity-vt': require('!raw-loader!../../../static/onboarding/diversity-VT.svg'),
  'currently-working': require('!raw-loader!../../../static/pools/currently-working.svg'),
  'previously-hired': require('!raw-loader!../../../static/pools/previously-hired.svg'),
  'candidate-hired': require('!raw-loader!../../../static/candidate/hired_banner.svg'),
  'candidate-hired-vt': require('!raw-loader!../../../static/candidate/hired_banner-VT.svg'),
  'feedback-aq': require('!raw-loader!../../../static/feedback-aq.svg'),
  'feedback-vt': require('!raw-loader!../../../static/feedback-vt.svg'),
  'hourglass': require('!raw-loader!../../../static/hourglass.svg'),
  'hourglass-alert': require('!raw-loader!../../../static/hourglass-alert.svg'),
  'clock': require('!raw-loader!../../../static/clock.svg'),
  'insufficient-data': require('!raw-loader!../../../static/diversity-insights/insufficient_data_icon.svg')
};

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent {

  @Input() name: string;

  constructor(private sanitizer: DomSanitizer) {
  }

  get svgIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(ICONS[this.name]);
  }
}

